import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, DataTable, Modal } from '../../../../common/components';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { refreshData } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, Row } from 'react-bootstrap';
import { closeModal, openModal } from '../../../../common/components/Modal/ModalRedux';
import { addInsurer, updateInsurer } from '../../redux/organisationActions';
import UploadCropComponent from '../../../../common/components/Upload/UploadCrop';
import { triggerFileUpload } from '../../../../common/components/Upload/UploadRedux';
import InfoButton from '../../../../common/components/InfoButton/InfoButton';
import EditDetailsForm from '../../../../common/components/EditDetailsForm/EditDetailsForm';

const FORM_NAME = 'insurerForm';

class OrganisationInsurers extends Component {
  state = {
    isNew: false,
  };

  componentWillUpdate(newProps) {
    const { dispatch, submitSucceeded } = this.props;

    if (newProps.submitSucceeded && !submitSucceeded) {
      dispatch(refreshData('insurers'));
      dispatch(closeModal(FORM_NAME));
    }
  }

  handleSubmit(values) {
    const { dispatch } = this.props;
    const { isNew } = this.state;

    return isNew
      ? dispatch(addInsurer(values))
      : dispatch(updateInsurer(values, this.props.resource));
  }

  handleUpload() {
    const { dispatch } = this.props;

    dispatch(triggerFileUpload());
  }

  handleUploadComplete(data) {
    const { dispatch, change } = this.props;

    dispatch(change('data.relationships.logo_file.data', data.data));
    dispatch(change('data.attributes.logo', data.data.attributes.url));
  }

  handleRowClick(row) {
    const { dispatch, change } = this.props;

    dispatch(change('data.id', row.id));
    dispatch(change('data.attributes', row));

    this.setState({
      isNew: false,
    });

    dispatch(openModal(FORM_NAME));
  }

  handleAddInsurer() {
    const { dispatch, reset, change, resource } = this.props;

    this.setState({
      isNew: true,
    });

    dispatch(reset());
    dispatch(change('data.relationships.organisation.data.id', resource.data.id));
    dispatch(openModal(FORM_NAME));
  }

  render() {
    const { resource, submitting, handleSubmit, formValues } = this.props;
    const { isNew } = this.state;
    const title = 'Edit Brand';

    const renderLogo = (
      <Row>
        <Col xs={4}>
          <label className="control-label">Insurer logo</label>
          &nbsp;
          <InfoButton
            content={
              ' Upload Brand logo, which will be applied to any schemes associated with this Brand imminently (impacting Scheme selection'
            }
          />
        </Col>
        <Col xs={8}>
          <img src={formValues?.data?.attributes?.logo} alt={'logo'} />
        </Col>
      </Row>
    );

    const submitButton = (
      <div>
        <Button
          type="button"
          bsStyle="primary"
          className="pad-right bottom-margin-0"
          disabled={submitting}
          handleClick={::this.handleUpload}
        >
          {submitting ? (
            <i className="fa fa-cog fa-spin" />
          ) : (
            <i className="fa fa-image" />
          )}{' '}
          upload logo
        </Button>
        <Button
          type="submit"
          bsStyle="primary"
          disabled={submitting}
          isLoading={submitting}
          label="Save"
        />
      </div>
    );

    return (
      <Box>
        <DataTable
          source="/organisations/insurers"
          name="insurers"
          showTotal
          autoFilters={[{ type: 'filter[organisation]', value: resource.data.id }]}
          onRowSelect={this.handleRowClick.bind(this)}
        >
          <TableHeaderColumn dataField="name" isKey>
            Name
          </TableHeaderColumn>

          <TableHeaderColumn dataField="id">Code</TableHeaderColumn>
        </DataTable>

        <Row className="margin-top">
          <Col xs={12}>
            <Button
              label="Add a Brand"
              className="pull-right"
              handleClick={::this.handleAddInsurer}
            />
          </Col>
        </Row>

        <Modal
          name={FORM_NAME}
          title={title}
          close
          handleSubmit={handleSubmit(::this.handleSubmit)}
          footer={submitButton}
        >
          <div>
            <EditDetailsForm
              context={'organisation'}
              isNew={isNew}
              formValues={formValues}
            />
            {renderLogo}
            <hr />
            <UploadCropComponent
              onComplete={::this.handleUploadComplete}
              width={355}
              height={238}
              bsSize="lg"
              circle={false}
              minScale={30}
            />
          </div>
        </Modal>
      </Box>
    );
  }
}

OrganisationInsurers.propTypes = {
  dispatch: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
};

const form = reduxForm({ form: FORM_NAME })(OrganisationInsurers);

const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state) => {
  const values = selector(state, 'data.id', 'data');

  return {
    formValues: values,
  };
};

export default connect(mapStateToProps)(form);
